import { AmountInput, type AmountInputProps } from './AmountInput'
import { CurrencySelect } from './CurrencySelect'

export interface CurrencyAmountInputProps extends Omit<AmountInputProps, 'unit' | 'unitControl'> {
  /** ISO code, or '' to fall back to `currencyFallback`. */
  currency: string
  /** Fired when the picker inside the field changes — typically updates every
   *  amount on the form, since one currency covers them all. */
  onCurrencyChange: (currency: string) => void
  currencyFallback?: string
  currencyDisabled?: boolean
}

/** Amount field whose trailing unit is an editable currency picker. */
export function CurrencyAmountInput({
  currency,
  onCurrencyChange,
  currencyFallback,
  currencyDisabled,
  ...amountProps
}: CurrencyAmountInputProps) {
  return (
    <AmountInput
      {...amountProps}
      unitControl={
        <CurrencySelect
          inline
          value={currency}
          onValueChange={onCurrencyChange}
          fallback={currencyFallback}
          disabled={currencyDisabled || amountProps.disabled}
        />
      }
    />
  )
}
